import React from "react";

const ParraAiChat = () => {
  return <div>ParraAiChat</div>;
};

export default ParraAiChat;
